(function () {
    var row = document.querySelector('.footer_wordmark-row');
    if (!row) return;
    if (!('IntersectionObserver' in window)) {
      row.classList.add('is-visible');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          row.classList.add('is-visible');
          observer.disconnect();
        }
      });
    }, { threshold: 0.25 });
    observer.observe(row);
  })();

(function () {
  function positionCircle(btn, circle, e) {
    var rect = btn.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    var maxX = Math.max(x, rect.width - x);
    var maxY = Math.max(y, rect.height - y);
    var diameter = Math.hypot(maxX, maxY) * 2;
    circle.style.left = x.toFixed(1) + 'px';
    circle.style.top = y.toFixed(1) + 'px';
    circle.style.width = diameter.toFixed(1) + 'px';
  }

  function decorate(btn) {
    if (btn.dataset.fillInit) return;
    if (btn.classList.contains('btn--icon')) return;
    btn.dataset.fillInit = '1';
    btn.classList.add('btn--fill');

    var textWrap = document.createElement('span');
    textWrap.className = 'btn--fill__text';
    while (btn.firstChild) textWrap.appendChild(btn.firstChild);

    var clip = document.createElement('span');
    clip.className = 'btn--fill__clip';
    clip.setAttribute('aria-hidden', 'true');
    var circle = document.createElement('span');
    circle.className = 'btn--fill__circle';
    clip.appendChild(circle);

    btn.appendChild(clip);
    btn.appendChild(textWrap);

    btn.addEventListener('mouseenter', function (e) { positionCircle(btn, circle, e); });
    btn.addEventListener('mouseleave', function (e) { positionCircle(btn, circle, e); });
  }

  function init() {
    document.querySelectorAll('.btn').forEach(decorate);
  }

  window.initFillButtons = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

 // Fix: CSS geometry properties (rx/ry) are not supported on mobile browsers.
    // Set them as SVG presentation attributes so rounded corners work everywhere.
    function initDottedBorderRx() {
      document.querySelectorAll('.dotted-border rect').forEach(function(rect) {
          var box = rect.closest('.dotted-box');
          var rx = 40;

          if (rect.closest('.product-card_size-btn') ||
              (box && box.matches('.product-card_option.dotted-box'))) {
              rx = 6;
          } else if (box && box.classList.contains('rounded-circle')) {
              rx = 999;
          } else if (box && box.classList.contains('rounded-l')) {
              rx = 20;
          } else if (rect.closest('.content-stat-cards_card')) {
              rx = 20;
          }

          rect.setAttribute('rx', rx);
          rect.setAttribute('ry', rx);
      });
  }
  initDottedBorderRx();